import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { RenovacaoService } from "../shared/service/renovacao/renovacao.service";
import { UtilService } from "../shared/service/util/util.service";

@Component({
  selector: "app-renovacao-certificado",
  templateUrl: "./renovacao-certificado.component.html",
  styleUrls: ["./renovacao-certificado.component.css"],
})
export class RenovacaoCertificadoComponent implements OnInit {
  // TODO: Criar validação que busca os dados do certificado e valida a data de expiração com a data atual, assim exibe a mensagem.
  desafio = "";
  loading = true;
  aceitouTermo = false;
  sucessoRenovar = false;
  certificadoExpirado = false;
  termoRenovacao = "";
  emailUsuario = "";
  pinUsuario = "";
  etapaAtual = 1;

  constructor(
    private route: ActivatedRoute,
    private utilService: UtilService,
    private renovacaoService: RenovacaoService
  ) {
    this.route.params.subscribe((params) => {
      this.desafio = params["desafio"];
      this.getTermo();
    });
  }

  ngOnInit() {}

  getTermo() {
    this.loading = true;
    this.renovacaoService
      .getTermoRenovacao(this.desafio)
      .then((data) => {
        this.emailUsuario = data.email;
        this.termoRenovacao = this.base64ParaTexto(data.termo).replace(
          /\n/g,
          "<br>"
        );
        this.loading = false;
      })
      .catch(() => {
        this.certificadoExpirado = true;
        this.loading = false;
      });
  }

  emitirRenovacao() {
    this.loading = true;
    this.renovacaoService
      .assinarTermo(
        this.desafio,
        this.termoRenovacao,
        this.emailUsuario,
        this.pinUsuario
      )
      .then((data) => {
        this.loading = false;
        this.sucessoRenovar = data.success;
        if(!data.success) this.utilService.showError(data.message);
      })
      .catch((error) => {
        this.loading = false;
        this.sucessoRenovar = false;
        this.utilService.showError(`${error}`);
      });
  }

  base64ParaTexto(base64: string): string {
    const binaryString = atob(base64);

    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return new TextDecoder("utf-8").decode(bytes);
  }
}
